import { render, staticRenderFns } from "./RevisionsHistoryModal.vue?vue&type=template&id=89bde158&"
import script from "./RevisionsHistoryModal.vue?vue&type=script&lang=js&"
export * from "./RevisionsHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports